"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fourDigits = /^[0-9]{4}$/;
var fiveDigits = /^[0-9]{5}$/;
var sixDigits = /^[0-9]{6}$/;
var sevenDigits = /^[0-9]{7}$/;
var threeSpaceTwo = /^[0-9]{3}[ ]?[0-9]{2}$/;
var countryCodeToRegex = {
    AD: /.*/,
    AE: /.*/,
    AT: fourDigits,
    AU: fourDigits,
    BE: fourDigits,
    BG: fourDigits,
    CA: /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    CH: fourDigits,
    CN: /^([0-9]{6})?$/,
    CY: fourDigits,
    CZ: threeSpaceTwo,
    DE: fiveDigits,
    DEFAULT: /^[a-zA-Z0-9\-\s]{1,}$/i,
    DK: fourDigits,
    EE: fiveDigits,
    ES: /^([0-4][0-9]|[5][0-2])[0-9]{3}$/,
    EU: /.*/,
    FI: fiveDigits,
    FR: fiveDigits,
    GB: /^[a-zA-Z]{1,2}([0-9]{1,2}|[0-9][a-zA-Z])\s*[0-9][a-zA-Z]{2}$/,
    GI: /^[A-Z]{1,2}[0-9]{1,2}[A-Z]?[0-9][A-Z]{2}$/,
    GR: threeSpaceTwo,
    HK: /.*/,
    HR: fiveDigits,
    HU: fourDigits,
    IE: /^([a-zA-Z0-9\s]{1,9})?$/,
    IL: sevenDigits,
    IN: sixDigits,
    IS: /^[0-9]{3}$/,
    IT: fiveDigits,
    JO: fiveDigits,
    JP: /^[0-9]{3}-[0-9]{4}$/,
    KR: /^([0-9]{3}[-]?[0-9]{3}|[0-9]{5})$/,
    LI: fourDigits,
    LT: /^(((LT)[-]?)?[0-9]{5})$/,
    LU: fourDigits,
    LV: /^(((LV)[-]?)?[0-9]{4})$/,
    MC: fiveDigits,
    MO: /.*/,
    MT: /.*/,
    MX: fiveDigits,
    NL: /^[0-9]{4}[ ]?[A-Za-z]{2}$/,
    NO: fourDigits,
    NZ: fourDigits,
    PL: /^[0-9]{2}-[0-9]{3}$/,
    PR: /^00[0-9]{3}$/,
    PT: /^[0-9]{4}-[0-9]{3}$/,
    RO: sixDigits,
    RS: /.*/,
    RU: /^[0-9]{6}$/,
    SE: threeSpaceTwo,
    SG: sixDigits,
    SI: /^(((SI)[-]?)?[0-9]{4})$/,
    SK: threeSpaceTwo,
    SM: fiveDigits,
    TH: fiveDigits,
    TR: /^[0-9]{4,5}$/,
    TW: /^([0-9]{3}[-]?([0-9]{0,2})?)$/,
    US: /^([0-9]{5})(-[0-9]{4})?$/,
};
exports.default = countryCodeToRegex;
